import {
	ltMdMediaQuery, ltSmMediaQuery,
} from 'root/src/client/web/commonStyles'

export default {
	root: {
		padding: [[80, 0, 45]],
		maxWidth: 1750,
		margin: [[0, 'auto']],
		width: '100%',
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
	},
	statisticsContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	statisticsItem: {
		marginBottom: '30px',
	},
	statContent: {
		display: 'inline',
		[ltSmMediaQuery]: {
			display: 'flex',
			justifyContent: 'center',
		},
	},
	strongStatContent: {
		marginBottom: '50px',
	},
	buttonsContainer: {
		width: '40%',
		display: 'flex',
		justifyContent: 'space-evenly',
		alignItems: 'center',
		margin: [[0, 'auto']],
		[ltMdMediaQuery]: {
			flexDirection: 'column',
		},
	},
	button: {
		minWidth: 180,
		margin: [[0, 0, 30, 0]],
	},
}
